'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp; /**
                    * Created by lyj on 2016/10/25.
                    */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactModal = require('react-modal');

var _reactModal2 = _interopRequireDefault(_reactModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CustomProductDetailTipModal = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(CustomProductDetailTipModal, _Component);

  // isEmptyObject: PropTypes.func

  function CustomProductDetailTipModal() {
    (0, _classCallCheck3.default)(this, CustomProductDetailTipModal);

    var _this = (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(CustomProductDetailTipModal).call(this));

    _this.state = {
      closeHover: false
    };
    return _this;
  }

  (0, _createClass3.default)(CustomProductDetailTipModal, [{
    key: 'customClick',
    value: function customClick() {
      var onCustomClick = this.props.onCustomClick;

      if (onCustomClick) {
        onCustomClick('tipModal');
      }
    }
  }, {
    key: 'packagingClick',
    value: function packagingClick() {
      var onPackagingClick = this.props.onPackagingClick;

      if (onPackagingClick) {
        onPackagingClick('tipModal');
      }
    }
  }, {
    key: 'serviceClick',
    value: function serviceClick() {
      var onServiceClick = this.props.onServiceClick;

      if (onServiceClick) {
        onServiceClick('tipModal');
      }
    }
  }, {
    key: 'analysisCustomContent',
    value: function analysisCustomContent() {
      var _props = this.props;
      var customData = _props.customData;
      var custom = _props.custom;

      var styles = require('./CustomProductDetailTipModal.scss');
      var itemDiv = [];
      // console.log(custom);
      if (customData) {
        var customMaterial = customData.customMaterial;
        var customItems = customData.customItems;
        // console.log(custom);
        // console.log(customMaterial);
        //  console.log(customItems);

        if (custom) {
          if (customMaterial instanceof Array) {
            customMaterial.forEach(function (currentInfo) {
              var chosenMaterial = custom.material;
              if (chosenMaterial[currentInfo.groupId] === currentInfo.id) {
                itemDiv.push(_react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { style: { width: '20%' } },
                    currentInfo.groupName
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: { width: '55%' } },
                    currentInfo.name
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: { width: '20%', float: 'right' } },
                    currentInfo.price ? '¥' + currentInfo.price : ''
                  )
                ));
              }
            });
          }

          if (customItems instanceof Array) {
            customItems.forEach(function (currentInfo) {
              var chosenItems = custom.customs;
              if (chosenItems[currentInfo.groupId] === currentInfo.id) {
                itemDiv.push(_react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { style: { width: '20%' } },
                    currentInfo.groupName
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: { width: '55%' } },
                    currentInfo.name
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: { width: '20%', float: 'right' } },
                    currentInfo.price ? '¥' + currentInfo.price : ''
                  )
                ));
              }
            });
          }
        }
      }
      var result = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.header },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            '定制'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' }),
        _react2.default.createElement(
          'div',
          { className: styles.itemTitle },
          !(custom.scheme === '') ? '已选定制' : '未选择定制'
        ),
        _react2.default.createElement(
          'div',
          { className: styles.itemContent },
          itemDiv
        ),
        _react2.default.createElement(
          'div',
          { className: styles.jumpContent },
          _react2.default.createElement(
            'span',
            { className: styles.choosenBtn, onClick: this.customClick.bind(this) },
            '选择定制'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );

      return result;
    }
  }, {
    key: 'analysisServiceContent',
    value: function analysisServiceContent() {
      var _props2 = this.props;
      var serviceData = _props2.serviceData;
      var services = _props2.services;

      var styles = require('./CustomProductDetailTipModal.scss');
      var result = '';
      if (serviceData) {
        var itemDiv = '';
        if (services) {
          itemDiv = services.split(',').map(function (currentServiceId) {
            var info = serviceData.find(function (serviceInfo) {
              return serviceInfo.id === currentServiceId;
            });
            var currentResult = false;
            if (info) {
              currentResult = _react2.default.createElement(
                'div',
                { key: currentServiceId },
                _react2.default.createElement(
                  'span',
                  { style: { width: '20%' } },
                  ''
                ),
                _react2.default.createElement(
                  'span',
                  { style: { width: '55%' } },
                  info.name
                ),
                _react2.default.createElement(
                  'span',
                  { style: { width: '20%', float: 'right' } },
                  info.price ? '¥' + info.price : ''
                )
              );
            }
            return currentResult;
          });
        }
        result = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              '服务'
            )
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.itemTitle },
            services ? '已选服务' : '未选择服务'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.itemContent },
            itemDiv
          ),
          _react2.default.createElement(
            'div',
            { className: styles.jumpContent },
            _react2.default.createElement(
              'span',
              { className: styles.choosenBtn, onClick: this.serviceClick.bind(this) },
              '选择服务'
            )
          ),
          _react2.default.createElement('div', { className: 'clear' })
        );
      }
      return result;
    }
  }, {
    key: 'analysisPackagingContent',
    value: function analysisPackagingContent() {
      var _props3 = this.props;
      var packagingData = _props3.packagingData;
      var packaging = _props3.packaging;

      var styles = require('./CustomProductDetailTipModal.scss');
      var result = '';
      if (packagingData) {
        var itemDiv = '';
        if (packaging) {
          (function () {
            var packagingInfo = packaging.split(',');
            if (packagingInfo.length === 2) {
              var info = packagingData.find(function (Info) {
                return Info.groupId === packagingInfo[0] && Info.id === packagingInfo[1];
              });
              if (info) {
                itemDiv = _react2.default.createElement(
                  'div',
                  null,
                  _react2.default.createElement(
                    'span',
                    { style: { width: '20%' } },
                    info.groupName
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: { width: '55%' } },
                    info.name
                  ),
                  _react2.default.createElement(
                    'span',
                    { style: { width: '20%', float: 'right' } },
                    info.price ? '¥' + info.price : ''
                  )
                );
              }
            }
          })();
        }
        result = _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(
              'div',
              { className: styles.title },
              '包装'
            )
          ),
          _react2.default.createElement('div', { className: 'clear' }),
          _react2.default.createElement(
            'div',
            { className: styles.itemTitle },
            packaging ? '已选包装' : '未选择包装'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.itemContent },
            itemDiv
          ),
          _react2.default.createElement(
            'div',
            { className: styles.jumpContent },
            _react2.default.createElement(
              'span',
              { className: styles.choosenBtn, onClick: this.packagingClick.bind(this) },
              '选择包装'
            )
          ),
          _react2.default.createElement('div', { className: 'clear' })
        );
      }
      return result;
    }
  }, {
    key: 'closeImgMouseOver',
    value: function closeImgMouseOver() {
      this.setState({
        closeHover: true
      });
    }
  }, {
    key: 'closeImgMouseLeave',
    value: function closeImgMouseLeave() {
      this.setState({
        closeHover: false
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var styles = require('./CustomProductDetailTipModal.scss');
      var _props4 = this.props;
      var isOpened = _props4.isOpened;
      var onSubmit = _props4.onSubmit;
      var onClose = _props4.onClose;
      var onBuyAtonce = _props4.onBuyAtonce;
      var allPrice = _props4.allPrice;

      var customStyle = {
        content: {
          background: '#ffffff',
          overflow: 'hidden',
          outline: 'none',
          zIndex: 9999,
          border: '0',
          borderRadius: '30px',
          boxShadow: '3px 2px 20px',
          bottom: 'auto',
          minHeight: '10rem',
          left: '50%',
          padding: '2rem 20px',
          position: 'fixed',
          right: 'auto',
          top: '50%',
          transform: 'translate(-50%,-50%)',
          minWidth: '40rem',
          width: '60rem',
          maxWidth: '80rem'
        }
      };
      var closeHover = this.state.closeHover;

      var hoverClassName = styles.zhuan_a;
      if (closeHover) {
        hoverClassName = styles.zhuan;
      }

      return _react2.default.createElement(
        _reactModal2.default,
        { style: customStyle, isOpen: isOpened },
        _react2.default.createElement(
          'div',
          { className: styles.close },
          _react2.default.createElement('img', { className: hoverClassName, onMouseOver: this.closeImgMouseOver.bind(this),
            onMouseLeave: this.closeImgMouseLeave.bind(this), onClick: function onClick() {
              return onClose();
            },
            src: 'http://tupian.goeasy.cn:9999/yipinwang/third/close.png', alt: '',
            width: '100%' })
        ),
        _react2.default.createElement(
          'form',
          { className: styles.component },
          this.analysisCustomContent(),
          this.analysisServiceContent(),
          this.analysisPackagingContent(),
          _react2.default.createElement('div', { className: 'clear' })
        ),
        _react2.default.createElement('div', { style: { width: '100%', height: 1, backgroundColor: '#ff0000', marginTop: 25 } }),
        _react2.default.createElement(
          'div',
          { className: styles.allPrice },
          '总金额：¥',
          allPrice
        ),
        _react2.default.createElement(
          'div',
          { className: styles.bottomDiv },
          _react2.default.createElement(
            'span',
            { className: styles.submitBtn, onClick: onSubmit },
            '加入购物车'
          ),
          _react2.default.createElement(
            'span',
            { className: styles.submitBtn, style: { marginRight: 60 }, onClick: onBuyAtonce },
            '立即购买'
          )
        ),
        _react2.default.createElement('div', { className: 'clear' })
      );
    }
  }]);
  return CustomProductDetailTipModal;
}(_react.Component), _class.propTypes = {
  isOpened: _react.PropTypes.bool,
  customData: _react.PropTypes.object,
  serviceData: _react.PropTypes.array,
  packagingData: _react.PropTypes.array,
  custom: _react.PropTypes.object,
  services: _react.PropTypes.string,
  packaging: _react.PropTypes.string,
  onCustomClick: _react.PropTypes.func,
  onServiceClick: _react.PropTypes.func,
  onPackagingClick: _react.PropTypes.func,
  onClose: _react.PropTypes.func,
  onSubmit: _react.PropTypes.func,
  onBuyAtonce: _react.PropTypes.func,
  allPrice: _react.PropTypes.number }, _temp);
exports.default = CustomProductDetailTipModal;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/CustomProductDetailTipModal/CustomProductDetailTipModal.js
 ** module id = 1323
 ** module chunks = 0
 **/